import { CommonConfig } from '@yodlee/common-components';
export const Color = CommonConfig.ColorConfigs;
